<style lang="stylus" scoped>
@import "../cardMap.stylus";
span,.font20 {
  cursor: pointer;
}
.font20:hover{
  color:#00a28a;
}
</style>
<template>
    <div class="map-province m-t radius-5" >
    <div v-if='titleType' class="font20" @click="toDot(item)">{{item.cityName||item.cityCode}}>></div>
    <div v-else class="font20">{{item.cityName||item.cityCode}}（网点编号：{{item.cityCode}}）</div>
    <div class="map-province-cont">
        <div
        class="map-province-lib"
        v-for="(it,index) in item.countItem"
        :key="index"
        >
        <div class="_lib1">{{handleMapTitle(it.dataType,it.timeSection)}}</div>
        <div class="_lib2">{{it.timeSection}}</div>
        <div class="_lib3">{{it.count}}</div>
        <div class="m-t-2 font14">
            <el-row>
            <el-col :span="12">
                <div class="color1">个人单卡</div>
            </el-col>
            <el-col :span="12">
                <div class="t-r">{{initNum(it.personalSingleCard)}}</div>
            </el-col>
            </el-row>
            <el-row class="m-t">
            <el-col :span="12">
                <div class="color1">个人多卡</div>
            </el-col>
            <el-col :span="12">
                <div class="t-r">{{initNum(it.personalMoreCard)}}</div>
            </el-col>
            </el-row>
            <el-row class="m-t">
            <el-col :span="12">
                <div class="color1">企业单卡</div>
            </el-col>
            <el-col :span="12">
                <div class="t-r">{{initNum(it.companySingleCard)}}</div>
            </el-col>
            </el-row>
            <el-row class="m-t">
            <el-col :span="12">
                <div class="color1">企业多卡</div>
            </el-col>
            <el-col :span="12">
                <div class="t-r">{{initNum(it.companyMoreCard)}}</div>
            </el-col>
            </el-row>
        </div>
        </div>
    </div>
    </div>
</template>
<script>
    export default {
        props:{
            item:{
                type:Object,
                required: true,
            },
            toDot:{
                type:Function,
                default:function(){

                }
            },
            titleType:{
                default:true,
                type:Boolean
            }
        },
        methods:{
            initNum(num) {
                num = this.format(num) + ''
                if (num.indexOf('.') == -1) {
                    return num
                }
                return num.split('.')[0]
            },
            format(num) {
                var res=num.toString().replace(/\d+/, function(n){ // 先提取整数部分
                    return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                        return $1+",";
                        });
                })
                return res;
            },
        }
    }
</script>